import { render } from "./DriversCard.vue?vue&type=template&id=f7d18112&scoped=true"
import script from "./DriversCard.vue?vue&type=script&lang=js"
export * from "./DriversCard.vue?vue&type=script&lang=js"

import "./DriversCard.vue?vue&type=style&index=0&id=f7d18112&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7d18112"]])

export default __exports__